if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.setupNavigation();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
      
      // Update current index when showing active media
      this.updateCurrentIndex();
    }

    setupNavigation() {
      const prevButton = this.querySelector('.product-media-modal__nav--prev');
      const nextButton = this.querySelector('.product-media-modal__nav--next');
      
      if (!prevButton || !nextButton) return;
      
      prevButton.addEventListener('click', () => this.navigateMedia('prev'));
      nextButton.addEventListener('click', () => this.navigateMedia('next'));
      
      // Keyboard navigation
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          this.navigateMedia('prev');
        } else if (e.key === 'ArrowRight') {
          this.navigateMedia('next');
        }
      });
    }

    navigateMedia(direction) {
      const mediaItems = Array.from(this.querySelectorAll('[data-media-id]'));
      const activeMedia = this.querySelector('[data-media-id].active');
      
      if (!activeMedia || mediaItems.length === 0) return;
      
      const currentIndex = mediaItems.indexOf(activeMedia);
      let newIndex;
      
      if (direction === 'prev') {
        newIndex = currentIndex > 0 ? currentIndex - 1 : mediaItems.length - 1;
      } else {
        newIndex = currentIndex < mediaItems.length - 1 ? currentIndex + 1 : 0;
      }
      
      const newMedia = mediaItems[newIndex];
      
      // Remove active class from all
      mediaItems.forEach(item => item.classList.remove('active'));
      
      // Add active class to new media
      newMedia.classList.add('active');
      newMedia.scrollIntoView({ behavior: 'smooth', block: 'center' });
      
      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (newMedia.width - container.clientWidth) / 2;
      
      // Load content if it's a deferred media
      const activeMediaTemplate = newMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      
      if (newMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube')) {
        newMedia.loadContent();
      }
    }

    updateCurrentIndex() {
      const mediaItems = Array.from(this.querySelectorAll('[data-media-id]'));
      const activeMedia = this.querySelector('[data-media-id].active');
      
      if (activeMedia) {
        this.currentIndex = mediaItems.indexOf(activeMedia);
      }
    }
  });
}